module.exports = __webpack_public_path__ + "img/weigouxuan@3x.adca7658.svg";